export default __webpack_public_path__ + "static/media/hoobastank.f60ca31f.jpg";